export default __webpack_public_path__ + "static/media/varified.d22be21a.svg";